import { render, staticRenderFns } from "./PokemonGoStatCalc.vue?vue&type=template&id=ae37d1d6&scoped=true&"
import script from "./PokemonGoStatCalc.vue?vue&type=script&lang=js&"
export * from "./PokemonGoStatCalc.vue?vue&type=script&lang=js&"
import style0 from "./PokemonGoStatCalc.vue?vue&type=style&index=0&id=ae37d1d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae37d1d6",
  null
  
)

export default component.exports